import { Link } from "react-router-dom";

var SkillsetBanner = require("components/writing/questions/SkillsetBanner");
var BookRating = require("components/reading/books/BookRating");
var CurrentUser = require("lib/account/CurrentUser");
var CoinsEarnedDisplay = require("components/reading/shelves/CoinsEarnedDisplay");
var MultiPartAnswerDisplay = require("components/writing/answers/MultiPartAnswerDisplay");

var EmptyStateContainer = require("components/utility/EmptyStateContainer");
var CommentBox = require("components/social/comments/CommentBox")
var Features = require('lib/account/Features');

require("reading/shelves/reviews_display.scss");

class ReviewsDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {  };
	}

	deleteReview(review) {
		if (confirm("Are you sure you want to delete this review?")) {
			CurrentUser.api().deleteAnswer(review.id, $wr.apiHandler(function(response) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Review Deleted", text: "You have deleted the review.", icon: "trash" });
				this.props.updateReviews(review);
			}.bind(this)));
		}
	}

	makeReviewDraft(review) {
		if (confirm("This will allow your student to make revisions to this review and resubmit. Are you sure?")) {
			var params = { answer: { draft: true, question_id: review.question_id } }
			CurrentUser.api().patchAnswer(review.id, params, $wr.apiHandler(function(response) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Review Updated", text: "You have allowed revisions for this review.", icon: "ok-sign" });
				this.props.updateReviews(review);
			}.bind(this)));
		}
	}

	render() {
		var book = this.props.book;

		if (book.reviews.length == 0 && !this.props.draftsOnly) {
			if (CurrentUser.isStudent()) {
				var reviewsContent = (
					<div className="emptySection">
						Reviews you write about this book go here. If you're done with 
						the book, <a href="#" onClick={ this.props.startReviewF }>write a review</a>!
					</div>
				);
			} else {
				var reviewsContent = (
					<div className="emptySection">
						There are no reviews written for this text yet.
					</div>
				);
			}
		} else {
			if (CurrentUser.isStudent()) {
				if (this.props.draftsOnly) {
					// only display the draft
					var sortedReviews = _.filter(book.reviews, function(answer) {
						return answer.draft == true;
					});
				} else {
					// sort to put the draft (if any) at the top
					var sortedReviews = _.sortBy(book.reviews, function(answer) {
						return answer.draft == false;
					});
				}

				if (sortedReviews.length > 0) {
					if (sortedReviews[0].draft) {
						var startReviewText = "Finish Review";
					} else {
						var startReviewText = "Write Another Review";
					}
				}

				if (!this.props.draftsOnly || sortedReviews.length > 0) {
					var reviewLink = (
						<div className="hideOnPrint">
							<a href="#" className="reviewLink"
								onClick={ this.props.startReviewF }>{ startReviewText }</a>
						</div>
					);
				}
			} else {
				// don't display the draft for admins
				var sortedReviews = _.filter(book.reviews, function(answer) {
					return answer.draft == false;
				});
			}

			// only display the header and the rating for draftsOnly if there is a draft to show
			if (!this.props.draftsOnly || sortedReviews.length > 0) {
				// change its opacity if its a draft
				if (this.props.draftsOnly) {
					var draftClassName = "draftReview";
				}
				var reviewHeader = (
					<SkillsetBanner skillset="review" classShelf={ true } className={ draftClassName } />
				);
				var ratings = book.ratings;
				if (ratings && ratings.length > 0) {
					var bookRating = (
						<div className="bookRating">
							<BookRating editable={ false } currentRating={ ratings[0].value } /> <br />
						</div>
					);
				}
			}

			var reviewsContent = sortedReviews.map(function(review, i) {
				if (review.draft) {
					var draftClassName = "draftReview";
				} else {
					if (CurrentUser.isAdmin()) {
						var dateText = $wr.formatDateTime(review.completed_at);
						var dateLine = (
							<span className="dateLine">
								{ dateText }
							</span>
						);
						var deleteLink = (
							<p className="removeReview hideOnPrint">
								<span className="verticalDivider" />
								<a href="#" onClick={ this.deleteReview.bind(this, review) }>
									Remove Review
								</a>
							</p>
						);
						var reviseLink = (
							<p className="reviseReview hideOnPrint">
								<span className="verticalDivider" />
								<a href="#" onClick={ this.makeReviewDraft.bind(this, review) }>
									Allow Revision
								</a>
							</p>
						);
					} else {
						// only show coin display if a student and not a draft
						var reviewCoinsDisplay = (
							<CoinsEarnedDisplay coinRecords={ review.gold_records } subjectType="reviews" />
						);
					}
				}
				var reviewsCount = sortedReviews.length;
				if (reviewsCount > 1 && i + 1 != reviewsCount) {
					var reviewClassName = "borderedReview";
				}

				if (Features.isEnabled(Features.TEACHER_COMMENTS)) {
					var commentBox = (
						<CommentBox subjectID={ review.id } subjectType="JournalActivityReview"
							blockFirstComment={ CurrentUser.isStudent() }
							userID={ review.user_id } initialCollapsed={ !CurrentUser.isStudent() } />
					)
				}
				return (
					<div className={ "bookReview " + reviewClassName + " " + draftClassName } key={ review.id }>
						<div className="ratingContainer">
							{ bookRating }
						</div>
						{ reviewCoinsDisplay }
						<p className="detailsViewPrompt">{ review.question_text }</p>
						{ dateLine }
						{ deleteLink }
						{ reviseLink }
						<div className="reviewText">
							<MultiPartAnswerDisplay parts={ review.parts } />
						</div>
						{ commentBox }
					</div>
				)
			}.bind(this));
		}
		return (
			<div className="reviewsContent">
				{ reviewLink }
				{ reviewHeader }
				{ reviewsContent }
			</div>
		)
	}
}

ReviewsDisplay.propTypes = StrictPropTypes({
	book: PropTypes.object.isRequired,

	// optional function, for linking to start a review in empty state or from drafts
	startReviewF: PropTypes.func,

	updateReviews: PropTypes.func,

	// whether to show only drafts
	draftsOnly: PropTypes.bool,
});

module.exports = ReviewsDisplay;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/ReviewsDisplay.js